import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const ToBottom16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M12.7461 9.01667L12.7451 9.01772L8.57068 13.2296C8.41147 13.4189 8.20279 13.5 8.00036 13.5C7.79783 13.5 7.59286 13.4195 7.43474 13.2591L3.25531 9.01737C2.92808 8.68233 2.9133 8.1286 3.22314 7.77771C3.53617 7.42147 4.05942 7.41084 4.3867 7.74452L8.00031 11.4116L11.6139 7.7417C11.9419 7.40758 12.4633 7.4208 12.7773 7.77556C13.0856 8.12789 13.0725 8.68139 12.7461 9.01667Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M12.7461 3.95868L12.7451 3.95974L8.57068 8.17166C8.41147 8.36093 8.20279 8.44202 8.00036 8.44202C7.79783 8.44202 7.59286 8.36154 7.43474 8.2011L3.25531 3.95939C2.92808 3.62435 2.9133 3.07062 3.22314 2.71972C3.53617 2.36349 4.05942 2.35285 4.3867 2.68654L8.00031 6.35362L11.6139 2.68372C11.9419 2.3496 12.4633 2.36282 12.7773 2.71758C13.0856 3.06991 13.0725 3.6234 12.7461 3.95868Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
